import {FC} from "react";
import {Table} from "semantic-ui-react";
import formatter from "../../util/dataFormatUtil";
import {
    IColumnMetadata,
    IDataTableData
} from "../../features/application/api/applicationModels";
import DataTableMetricValueDisplayElement from "./DataTableMetricValueDisplayElement";

interface IDataTableFooterProps {
    footerData: IDataTableData[];
    staticColumns: IColumnMetadata[];
    configurableColumns: IColumnMetadata[] | undefined;
    isMobileScreen: boolean;
}
const DataTableFooter: FC<IDataTableFooterProps> = ({
    footerData,
    staticColumns,
    configurableColumns,
    isMobileScreen
}) => {
    return (
        <Table.Footer>
            {footerData.map((row, rowIndex) => (
                <Table.Row className={"boldRow"} key={"FooterRow" + rowIndex}>
                    {staticColumns.map((column, columnIndex) => (
                        <Table.Cell key={"FooterCell" + columnIndex + column.key}>
                            <DataTableMetricValueDisplayElement
                                isMobileScreen={isMobileScreen}
                                metricName={column.label}
                                metricDisplayValue1={formatter.dataTableDisplayValue(
                                    row[column.key],
                                    column
                                )}
                            />
                        </Table.Cell>
                    ))}
                    {configurableColumns?.map((column, columnIndex) => (
                        <Table.Cell key={"FooterCell" + columnIndex + column.key}>
                            <DataTableMetricValueDisplayElement
                                isMobileScreen={isMobileScreen}
                                metricName={column.label}
                                metricDisplayValue1={formatter.dataTableDisplayValue(
                                    row[column.key],
                                    column
                                )}
                            />
                        </Table.Cell>
                    ))}
                </Table.Row>
            ))}
        </Table.Footer>
    );
};

export default DataTableFooter;
